import * as React from 'react';
import type {EngineConfig} from './EngineConfigProvider';
import {EngineConfigProvider} from './EngineConfigProvider';

export const EngineProvider: React.FC<
  React.PropsWithChildren<EngineConfig>
> = ({children, ...config}) => {
  const stableConfig: EngineConfig = React.useMemo(
    () => ({
      cssPolicy: config.cssPolicy || "runtime-only",
    }),
    [config.cssPolicy],
  );

  return (
    <EngineConfigProvider config={stableConfig}>
      {children}
    </EngineConfigProvider>
  );
};
